import { Expose, Type } from 'class-transformer';
import { TruckOperationStatus } from '../../shared-features/enums/fleets.enum';
import { Model } from '@shared/models/model';
import { User } from '../../users/models/user.model';

export class StatusHistory extends Model {
  @Expose() from: string;
  @Expose() to: string;
  @Expose() status: TruckOperationStatus;
  @Type(() => User)
  @Expose()
  createdBy: User;

  constructor() {
    super();
  }
}
